import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';

const { 
  FiHome, FiUsers, FiBriefcase, FiCheckSquare, 
  FiFileText, FiDollarSign, FiBarChart3, FiSettings, 
  FiShield, FiUserPlus, FiClock, FiLayout 
} = FiIcons;

const Sidebar = ({ isOpen }) => {
  const { user } = useAuth();
  const { businessSettings } = useData();

  const menuItems = [
    { path: '/dashboard', icon: FiHome, label: 'Dashboard' },
    { path: '/companies', icon: FiBriefcase, label: 'Companies' },
    { path: '/contacts', icon: FiUsers, label: 'Contacts' },
    { path: '/lead-forms', icon: FiLayout, label: 'Lead Forms' },
    { path: '/team', icon: FiUserPlus, label: 'My Team' },
    { path: '/projects', icon: FiBriefcase, label: 'Projects' },
    { path: '/tasks', icon: FiCheckSquare, label: 'Tasks' },
    { path: '/timesheets', icon: FiClock, label: 'Time Tracking' },
    { path: '/proposals', icon: FiFileText, label: 'Proposals' },
    { path: '/invoices', icon: FiDollarSign, label: 'Invoices' },
    { path: '/reports', icon: FiBarChart3, label: 'Reports' },
    { path: '/settings', icon: FiSettings, label: 'Settings' }
  ];

  if (user?.role === 'SUPER ADMIN') {
    menuItems.push({ path: '/admin', icon: FiShield, label: 'Admin Console' });
  }

  return (
    <motion.aside 
      initial={false}
      animate={{ width: isOpen ? 256 : 80 }}
      className="bg-white shadow-lg border-r border-gray-200 flex flex-col h-screen sticky top-0 z-40"
    >
      <div className="p-6 border-b border-gray-100">
        <div className="flex items-center space-x-3 overflow-hidden">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0 shadow-lg shadow-blue-100">
            {businessSettings.logo ? (
              <img src={businessSettings.logo} alt="Logo" className="w-full h-full object-cover rounded-lg" />
            ) : (
              <SafeIcon icon={FiBriefcase} className="text-white text-lg" />
            )}
          </div>
          {isOpen && (
            <span className="text-xl font-black text-slate-900 tracking-tighter truncate">
              {businessSettings.companyName || 'JINXos'}
            </span>
          )}
        </div>
      </div>

      <nav className="flex-1 p-4 space-y-1 overflow-y-auto custom-scrollbar">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => 
              `flex items-center space-x-3 px-3 py-3 rounded-2xl transition-all group ${
                isActive 
                  ? 'bg-blue-600 text-white shadow-lg shadow-blue-100' 
                  : 'text-slate-500 hover:bg-slate-50 hover:text-slate-900'
              }`
            }
          >
            <SafeIcon icon={item.icon} className={`text-xl flex-shrink-0 ${isOpen ? '' : 'mx-auto'}`} />
            {isOpen && <span className="font-bold text-sm tracking-tight">{item.label}</span>}
          </NavLink>
        ))}
      </nav>
    </motion.aside>
  );
};

export default Sidebar;